import _ from 'lodash';
import React from 'react';
import { change, Field, getFormValues } from 'redux-form';
import { RenderToggleSwitch } from 'src/components/views/common/forms/render-toggle-switch';
import { withI18n } from '@shopify/react-i18n';
import { RenderRangeSlider } from 'src/components/views/common/forms/render-range-slider';
import { connect } from 'react-redux';
import { allowUsingNewSearchSettings } from 'src/helpers/search-settings-helper';
import { AI_POWERED_SEARCH_NAME } from 'src/constants/subscription';
import moment from 'moment';

const SemanticSettings = props => {
  const { i18n, semanticSetting, formValues, isNewSearch } = props;
  const { available } = semanticSetting || {};
  const { enable } = formValues;

  const checkShowEnableField = () => {
    const { addonStatus = {}, chargeInfoActive = {} } = props;
    const { subscribedAt = 0 } = addonStatus;
    // Check store
    if (subscribedAt === 0) {
      // Add on has not subscribe, check package is activate before 21/06/2024
      const { activated_on = '2024-06-21' } = chargeInfoActive || {};
      if (moment(`${activated_on} 00:00:00`).diff('2024-06-21 00:00:00', 'days') < 0) {
        return true;
      }
    } else if (subscribedAt < 1718928000) {
      // Check add on is subscribe before 21/06/2024 => show enable
      return true;
    }
    return false;
  };

  const isShowEnableField = checkShowEnableField();
  return (
    <>
      {isShowEnableField && (
        <div className="enable-semantic-search">
          <Field
            name={`enable`}
            disabled={!isNewSearch}
            component={RenderToggleSwitch}
            label={i18n.translate('AdminHTML.SemanticSearch.Setting.enable')}
          />
        </div>
      )}
      {available && enable && isNewSearch && (
        <div className="semantic-setting">
          <div className="content">
            <span className="title">
              {i18n.translate('AdminHTML.SemanticSearch.Setting.title')}
            </span>
            <span className="description">
              {i18n.translate('AdminHTML.SemanticSearch.Setting.weightContent')}
            </span>
          </div>
          <div className="setting-weight">
            <Field
              name={`weight`}
              component={RenderRangeSlider}
              beforeOutput={i18n.translate('AdminHTML.SemanticSearch.Setting.beforeSliderOutput')}
              afterOutput={i18n.translate('AdminHTML.SemanticSearch.Setting.afterSliderOutput')}
              parentClass={'.BC-Page .BC-Page__Semantic .semantic-setting'}
              parse={value => value * 0.01}
              format={value => value * 100}
              step={25}
              min={25}
            />
          </div>
        </div>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateField: (field, value) => dispatch(change(`SemanticSearchForm`, field, value))
});
const mapStateToProps = state => {
  const semanticSetting = _.get(state.semantic, 'settings', {
    enable: false,
    weight: 0.5
  });
  const formValues = getFormValues('SemanticSearchForm')(state);
  const searchVersion = _.get(state.oauth, 'tenantApp.parseParams.searchVersion', '1.0');
  const isNewSearch = allowUsingNewSearchSettings(searchVersion);

  return {
    semanticSetting,
    formValues,
    isNewSearch,
    addonStatus: _.get(state.subscriptionV3, `addonStatus.${AI_POWERED_SEARCH_NAME}`, {}),
    chargeInfoActive: _.get(state.oauth, 'tenantApp.chargeInfoActive', {})
  };
};

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(SemanticSettings));
